import React, { useEffect, useRef } from "react";
import "./about.scss";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { HiOutlineUser } from "react-icons/hi2";

gsap.registerPlugin(ScrollTrigger);

export default function About() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const ctx = gsap.context(() => {
      gsap.fromTo(
        ".about__header",
        { y: 14, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.5,
          ease: "power3.out",
          scrollTrigger: {
            trigger: el,
            start: "top 84%",
            toggleActions: "play none none reverse",
          },
        }
      );

      gsap.fromTo(
        ".about__fade",
        { y: 12, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.45,
          ease: "power3.out",
          stagger: 0.08,
          scrollTrigger: {
            trigger: ".about__grid",
            start: "top 85%",
            toggleActions: "play none none reverse",
          },
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="about" id="About" ref={sectionRef}>
      <div className="about__container">
        <div className="about__header">
          <h2 className="about__title">
            <span className="about__titleIcon" aria-hidden="true">
              <HiOutlineUser />
            </span>
            About
          </h2>
          <div className="about__line" />
        </div>

        <div className="about__grid">
          {/* LEFT */}
          <div className="about__left about__fade">
            <p className="about__intro">
              I’m a <span>Software Engineer</span> with 4+ years of experience
              building scalable backend systems and cloud-native applications.
            </p>

            <div className="about__skillsWrap">
              <div className="about__subTitle">Core skills</div>

              <div className="about__skillsGrid">
                <div className="about__skillBlock">
                  <div className="about__skillTitle">Frontend</div>
                  <div className="about__skillText">
                    React • TypeScript • JavaScript • Angular • HTML • CSS
                  </div>
                </div>

                <div className="about__skillBlock">
                  <div className="about__skillTitle">Backend</div>
                  <div className="about__skillText">
                    Java • Spring Boot • Node.js • Express • Python • REST APIs
                  </div>
                </div>

                <div className="about__skillBlock">
                  <div className="about__skillTitle">Cloud / DevOps</div>
                  <div className="about__skillText">
                    AWS • Azure • GCP • Docker • Kubernetes • Terraform • CI/CD
                  </div>
                </div>

                <div className="about__skillBlock">
                  <div className="about__skillTitle">Data</div>
                  <div className="about__skillText">
                    SQL • PostgreSQL • MySQL • MongoDB • DynamoDB • Redis •
                    Kafka
                  </div>
                </div>

                <div className="about__skillBlock">
                  <div className="about__skillTitle">Monitoring & Security</div>
                  <div className="about__skillText">
                    Prometheus • Grafana • ELK Stack • OAuth2 • JWT • RBAC
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT */}
          <div className="about__right about__fade">
            <div className="about__eduCard">
              <div className="about__eduTop">
                <div>
                  <div className="about__eduTitle">Education</div>
                  <div className="about__eduHint">Academic background</div>
                </div>

                <div className="about__eduBadge">UTA • RNSIT</div>
              </div>

              <div className="about__eduList">
                <div className="about__eduRow">
                  <div className="about__eduDot" />
                  <div className="about__eduBody">
                    <div className="about__eduSchool">
                      University of Texas at Arlington
                    </div>
                    <div className="about__eduDegree">
                      M.S. in Computer Science
                    </div>
                    <div className="about__eduMeta">
                      Arlington, Texas • 2023 — 2025
                    </div>
                  </div>
                </div>

                <div className="about__eduRow">
                  <div className="about__eduDot" />
                  <div className="about__eduBody">
                    <div className="about__eduSchool">
                      RNS Institute of Technology
                    </div>
                    <div className="about__eduDegree">
                      B.E. in Information Science
                    </div>
                    <div className="about__eduMeta">
                      Bangalore, Karnataka • 2017 — 2021
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
